'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripStappenplanV1.$inject = ['ApiService', '$log'];


var _module = angular.module('cb.strips.cbStappenplanV1', []);
var _ = {
    each: _each3.default
};

_module.directive('cbStripStappenplanV1', cbStripStappenplanV1);

exports.default = _module;


function cbStripStappenplanV1(ApiService, $log) {
    return {
        restrict: 'A',
        link: cbStripStappenplanV1Link,
        controller: StappenplanController,
        controllerAs: 'stappenplan'
    };

    function cbStripStappenplanV1Link(scope, element, attrs) {}
}

function StappenplanController() {
    var vm = this;

    vm.openStep = openStep;

    function openStep(step, disabled) {
        if (disabled) {
            return;
        }
        if (vm.activeStep == step) {
            vm.activeStep = 0;
        } else {
            vm.activeStep = step;
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/stappenplan-v1/stappenplan.directive.js
// module id = 957
// module chunks = 1